export const headerConfig = {
    7: 'static',
    8: 'static',
    11: 'static',
    12: 'static',
    18: 'static',
    29: 'static',
    30: 'static',
    202: 'static',
    203: 'static',
    204: 'static',
    205: 'static',
    210: 'static',
    212: 'static',
    214: 'static',
    310: 'static',
    311: 'static',
    312: 'static',
    231: 'static',
    330: 'static',
    240: 'static',
    331: 'static',
    250: 'static',
    255: 'static'
};
